import { useRef, useState, useCallback, useEffect } from "react";
import { getRequest, postRequest } from "../../utils/api";
import { logout } from "../../utils/auth";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const Organizations = () => {

  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [tenantList, setTenantList] = useState<any[]>([]);
  const [tenantItem, setTenantItem] = useState<any>(null);

  const [isLoader, setIsLoader] = useState<any>(true);


  const getTenantList = useCallback(async (currentPage: number) => {
    try {
      setIsLoader(true)
      const response = await getRequest(`/tenant/getTenantList?page=${currentPage}`);
      if (response.status === 'success') {
        setTenantList(response.tenants);
        setTotalPages(response.totalPages);

        setIsLoader(false);
      }
      else if (response.status == 'session_expired') {
        setIsLoader(false)
        logout()
      }
      else {
        setIsLoader(false)
        toast.error(response.message);
      }
    } catch (error) {
      setIsLoader(false)
      toast.error("Something went wrong!");
    }
  }, []);


  useEffect(() => {
    getTenantList(page);
  }, [page, getTenantList]);


  const handleEdit = (item: any) => {
    setTenantItem(item);
    // Form values will be populated via useEffect in AddTenant based on tenantItem
  };

  const deleteTenant = async (id: string) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    if (result.isConfirmed) {
      const res = await postRequest("/tenant/deleteTenant", { tenant_id: id });
      if (res.status === "success") {
        toast.success(res.message);
        getTenantList(page);
      } else {
        toast.error(res.message);
      }
    }
  };
  const navigate = useNavigate();
  return (
    <div className="hk-pg-wrapper">
      <div className="hk-pg-body py-0">
        <div className="page-wrap">
          <div className="page-content ps-0">
            <div className="page-detail-wrap">
              <header className="page-header">
                <div>
                  <div className="page-title">
                    <h2 className="mb-0">Manage Organizations</h2>
                  </div>
                </div>
                <div className="page-options-wrap">

                  <div className="v-separator d-lg-inline-block d-none"></div>
                  <button type="button" className="btn btn-dark btn-rounded"
                    onClick={() =>
                      navigate("/organizations-partner/add-new-organization")
                    }>
                    <span>
                      <span className="icon"><i className="ri-add-line bticon"></i></span>
                      <span>Create New</span>
                    </span>
                  </button>

                  <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                    href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                    data-bs-original-title="Collapse">
                    <span className="btn-icon-wrap">
                      <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                      <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                    </span>
                  </a>
                </div>
              </header>
              <div className="page-body">
                <div data-simplebar className="nicescroll-bar">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="table-responsive">
                            <table className="table table-hover mb-0">
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Organizations Details</th>
                                  <th>Domain</th>
                                  <th className="text-center">Status</th>
                                  <th>Create Date</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tenantList && tenantList.length > 0 ? (
                                  tenantList.map((item, index) => (
                                    <tr>
                                      <td><a href="#" className="fw-bold">#</a></td>
                                      <td>
                                        <div className="media align-items-center">
                                          <div className="media-head me-2">
                                            <div className="avatar avatar-xs rounded">
                                              <img src="dist/img/logo-avatar-3.png" alt="user" className="avatar-img" />
                                            </div>
                                          </div>
                                          <div className="media-body">
                                            <h6 className="fs-14 mb-0">{item.name}</h6>
                                            <p className="mb-0 fs-12">–</p>
                                          </div>
                                        </div>
                                      </td>
                                      <td><a href="#" className="fw-bold">{item.domain}</a></td>
                                      <td className="text-center">
                                        {item.status === 1 && <span className="badge bg-success rounded-pill">APPROVED</span>}
                                        {item.status === 0 && <span className="badge bg-warning rounded-pill">UNAPPROVED</span>}
                                      </td>
                                      <td>{moment(item.createdAt).format('DD MMM, YYYY')}</td>
                                      <td className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                          <div className="d-flex gap-1">
                                            <a className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover" data-bs-toggle="tooltip" data-placement="top" title="" data-bs-original-title="Edit" href={`/organizations-partner/edit-organization/${item._id}`}>
                                              <span className="icon">
                                                <i className="ri-pencil-fill"></i>
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) :
                                  (
                                    <tr>
                                      <td colSpan={10}>
                                        <div className="text-center">No Record Found</div>
                                      </td>
                                    </tr>
                                  )
                                }

                              </tbody>
                            </table>
                          </div>
                          <div className="card-footer d-flex justify-content-between align-items-center">

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Organizations